import { call, put, takeLatest, select } from 'redux-saga/effects'
import { errorHandler } from '@/core/helpers/errorHelpers'

import * as awaitingKickOffView from '../reducks/awaitingKickOff'

import { companyId } from '@/core/selectors/sessions'
import { getAccountManager } from '@/core/apiModules/accountManager'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchAccountManagerSaga() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getAccountManager, id)
    yield put(awaitingKickOffView.fetchAccountManagerSuccess(response))
  } catch (err) {
    const { error, status } = yield call(errorHandler, err)
    yield put(awaitingKickOffView.fetchAccountManagerError(error))

    // Don't show system error if no account manager assigned
    if (status !== 404) {
      yield put(showSystemError(error))
    }
  }
}

export default function* watchAwaitingKickOffSaga() {
  yield takeLatest(awaitingKickOffView.FETCH_ACCOUNT_MANAGER, fetchAccountManagerSaga)
}
